import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Form = styled.form`
  display: flex;
  justify-content: space-between;
  ${media.small`
    border-top: solid 1px ${props => props.theme.borderColorRevert};
  `};
`;

export const ServiceTypeOption = styled.div`
  padding: ${p => p.theme.sideBasket.serviceType.padding};
`;

export const Label = styled.label`
  color: ${props => props.isDisabled ? props.theme.disabledTextColor : props.theme.quaternaryColor};
  margin-left: 0.6rem;
  font-size: ${props => props.theme.menuPage.basket.total.fontSize};
  font-weight: ${props => props.isDisabled ? 'normal' : 'bold'};
  ${media.small`
    color: ${props => props.isDisabled ? props.theme.disabledTextColor : props.theme.primaryColor};
  `};
`;

export const LabelNote = styled.span`
  color: ${props => props.eta ? props.theme.sideBasket.serviceTypeRadioButtonEtaNoteColor : props.theme.sideBasket.serviceTypeRadioButtonNoteColor};
  font-size: ${props => props.theme.sideBasket.serviceTypeRadioButtonNoteFontSize};
  line-height: ${props => props.theme.sideBasket.serviceTypeRadioButtonNoteFontSize};
  font-weight: normal;
  display: block;
  text-transform: lowercase;
  ${media.small`
    display: none;
  `};
`;



// WEBPACK FOOTER //
// ./components/ServiceTypeRadioButtons/ServiceTypeRadioButtons.style.js